import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonPage, IonRow, IonTitle, isPlatform } from "@ionic/react";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { CustomLoading, Header } from "../../components";
import { db } from "../../data/db/db";
import { ArticleCuttingParams } from "../../models/articleModel";
import { getMaterialGroups, materialGroupsFormatting } from "./aeMapping";

import "./CuttingData.scss";
import { useTranslation } from "react-i18next";

interface CuttingDataTroProps extends RouteComponentProps<{
    ident: string,
    pos: string
}> { }

const CuttingDataTro: React.FC<CuttingDataTroProps> = ({ match }) => {
    const ident = match.params.ident;
    const pos = match.params.pos;
    const [identState, setIdentState] = useState<string | null>();
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation();
    const materialGroups = getMaterialGroups(t);

    useEffect(() => {
        if (ident) {
            let str = ident.slice(0, 3) + " " + ident.slice(3, 5) + " " + ident.slice(5, 8)
            setIdentState(str.toUpperCase())
        }

        return () => {
            //unmount
            setIdentState(null);
        }
    }, [ident])

    const article: ArticleCuttingParams | undefined = useLiveQuery(
        async () => {
            if (identState && pos) {
                setLoading(true);
                const articles = await db.articlesCuttingParamsTro
                    .where({ ident: identState, pos: pos })
                    .first()
                setLoading(false)
                // Return result
                //console.log(articles)
                return articles;
            }

        },
        [identState, pos]
    );

    return (
        <IonPage>
            <Header>
                <IonButtons slot="start">
                    <IonBackButton defaultHref={"/tabs/calculator/preselection/sku1=" + ident} text={isPlatform('ios') ? t("Zurück") : undefined} />
                </IonButtons>
                <IonTitle>{t("Schnittwerte")}</IonTitle>
            </Header>
            <IonContent>
                <IonGrid fixed={true} className="mainContent">
                    <IonRow>
                        <IonCol size="12">
                            <div className="cuttingDataContainer">
                                {article && <div>
                                    <h2 className="cuttingDataTitle">{article.ident}-{article.pos}</h2>
                                    {Object.entries(article.data).map(([key, value]) => {
                                        return (
                                            <div key={key}>
                                                <div className="row">
                                                    <div className="leftMaterialCol" style={{ backgroundColor: `var(--mc-${key}-dark)` }}>{materialGroupsFormatting(key).toLocaleUpperCase()}<br /><span className="materialGroup">{materialGroups[key]}</span></div>
                                                    <div className="rightMaterialCol" style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                        <table className="materialTable">
                                                            <tbody>
                                                                <tr style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                                    <td><b>v<sub>c</sub></b></td>
                                                                    <td className="secondTableCol"><b>{value.vc.toFixed(1)}</b> m/min</td>
                                                                </tr>
                                                                <tr style={{ backgroundColor: `var(--mc-${key}-hm)` }}>
                                                                    <td><b>h<sub>max</sub></b></td>
                                                                    <td className="secondTableCol"><b>{value.hmax.toFixed(3)}</b> mm</td>
                                                                </tr>
                                                                <tr style={{ backgroundColor: `var(--mc-${key}-hm)` }}>
                                                                    <td><b>f<sub>z</sub></b></td>
                                                                    <td className="secondTableCol"><b>{value.fz.toFixed(3)}</b> mm</td>
                                                                </tr>
                                                                <tr style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                                    <td>&#946;<sub>min</sub></td>
                                                                    <td className="secondTableCol">{value.winkelMin.toFixed(1)}°</td>
                                                                </tr>
                                                                <tr style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                                    <td>&#946;<sub>max</sub></td>
                                                                    <td className="secondTableCol">{value.winkelMax.toFixed(1)}°</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>}

                                {!loading && !article && <p>{t("Wir haben leider keine Daten zu ... gefunden", { params: identState + "-" + pos })}</p>}
                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
            <CustomLoading isOpen={loading} />
        </IonPage>
    )
}

export default CuttingDataTro;